<template>
  <div class="p10 br10 box-s">
    <!-- {{ value }} -->
    <div class="acsa">
      <div v-for="(title, index) in searchConfig" class="p4" :key="index" :style="getColumnStyle(title)">
        {{ title.name }}
      </div>
    </div>
    <draggable v-model="localValue" handle=".search_item">
      <div v-for="(item, index) in localValue" :key="index">
        <div class="acsb p4 mb4 br10" :style="getRowStyle(index)" style="border: 1px #eee solid">
          <!-- {{ item }} -->

          <div v-for="(rowConfig, x) in searchConfig" :key="x" :style="getColumnStyle(rowConfig)" class="p2">
            <div class="fs18 p2" v-if="rowConfig.value == 'option'">
              <i class="el-icon-delete mr6" style="color: red" @click="deleteRow(localValue, rowIndex)"></i>
              <span>
                <i class="el-icon-rank search_item"></i>
              </span>
            </div>
            <div v-else-if="rowConfig.value == 'content'">
              <div v-if="item.type == '按钮单选'" class="ac wrap">
                <div v-for="(content, contentIndex) in item.content" :key="contentIndex">
                  <div class="ac mr4 p2 br4 box-s mb4">
                    <el-input v-model="content.name" placeholder="请输入"></el-input>
                    <i class="el-icon-delete ml4" style="color: red" @click="deleteRow(item.content, contentIndex)"></i>
                  </div>
                </div>

                <el-button type="primary" size="mini" class="ml4" @click="add_to_rows(item.content, {name: ''})">添加</el-button>
              </div>

              <div v-if="item.type === '下拉单选'">
                <el-input v-model="item.option_url" placeholder="请输入选项接口"></el-input>
              </div>
            </div>

            <div class="flex1" v-else>
              <el-select v-model="item[rowConfig.value]" placeholder="请选择" filterable v-if="rowConfig.type == 'select'">
                <el-option v-for="(option, oo) in rowConfig.options" :key="oo" :label="option.label" :value="option.value"> </el-option>
              </el-select>

              <el-input v-model="item[rowConfig.value]" v-else placeholder="请输入"></el-input>
            </div>
          </div>
        </div>
      </div>
    </draggable>
    <div class="acsb">
      <div></div>
      <el-button type="primary" size="mini" @click="add_to_rows(localValue, {type: '', content: []})">添加</el-button>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import _ from 'lodash'
export default {
  components: {draggable},
  props: {
    value: {
      type: null,
      default: null
    }
  },

  data() {
    const typeOptions = [
      {
        label: '精准搜索',
        value: ''
      },
      {
        label: '模糊搜索',
        value: '模糊搜索'
      },
      {
        label: '按钮单选',
        value: '按钮单选'
      },
      {
        label: '日期时间',
        value: '日期时间'
      },
      {
        label: '下拉单选',
        value: '下拉单选'
      },
      {
        label: '开始结束时间',
        value: '开始结束时间'
      },
      {
        label: '月份选择',
        value: '月份选择'
      }
    ]
    return {
      localValue: [],
      searchConfig: [
        {
          name: '类型',
          value: 'type',
          type: 'select',
          width: 120,
          options: typeOptions
        },
        {
          name: '标题',
          value: 'title',
          width: 120
        },
        {
          name: '字段',
          value: 'key',
          width: 120
        },
        {
          name: '默认',
          value: 'default',
          width: 120
        },

        {
          name: '内容',
          value: 'content'
        },
        {
          name: '操作',
          value: 'option',
          width: 60
        }
      ]
    }
  },

  created() {
    this.localValue = _.cloneDeep(this.value)
    // setTimeout(() => {

    // }, 100)
  },
  watch: {
    localValue: {
      handler(newVal) {
        if (!this.isEqual(newVal, this.value)) {
          this.$emit('input', _.cloneDeep(newVal)) // 值变化时通知父级
          // this.change_value()
        }
      },
      deep: true
    },
    value: {
      handler(newVal) {
        this.localValue = _.cloneDeep(newVal)
      }
    }
  },
  methods: {
    add_to_rows(rows, item) {
      rows.push(item)
    },
    deleteRow(rows, index) {
      this.$confirm('确认删除？', '提示', {type: 'warning'})
        .then(() => rows.splice(index, 1))
        .catch(() => this.$message.info('已取消删除'))
    },
    isEqual(a, b) {
      // 智能值比对（处理所有数据类型）
      if (typeof a !== typeof b) return false
      if (typeof a === 'object' && a !== null && b !== null) {
        // 处理引用类型
        return _.isEqual(a, b) // 使用 lodash 深度比对
      }
      return a === b // 基本类型直接比对
    },
    getColumnStyle(column) {
      return {
        width: column.width ? column.width + 'px' : '',
        flex: column.width ? '' : 1
      }
    },
    getRowStyle(rowIndex) {
      return rowIndex % 2 === 0 ? {} : {'background-color': 'rgba(240, 240, 240, 0.9)'}
    }
  }
}
</script>

<style lang="scss" scoped></style>
